import { render } from "./CouponList.vue?vue&type=template&id=193f8818&scoped=true&ts=true"
import script from "./CouponList.vue?vue&type=script&lang=ts"
export * from "./CouponList.vue?vue&type=script&lang=ts"

import "./CouponList.vue?vue&type=style&index=0&id=193f8818&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193f8818"]])

export default __exports__